<template>
  <div class="submit">
    <img src="../assets/contact.png" alt="" class="submit-top" />
    <div class="submit-background">
      <div class="submit-content">
        <p>您可以填写表单信息 我们将尽快与您联系</p>
        <div class="submit-content-sub">
          金币数:{{ logon.coins || "0" }}（一次发布扣除2个金币）
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="180px"
        >
          <!-- 原有表单内容不变 -->
          <el-form-item prop="type" label="项目类型">
            <el-select v-model="ruleForm.type" placeholder="请选择项目类型">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="projectName" label="项目名称">
            <el-input
              v-model="ruleForm.projectName"
              placeholder="请输入项目名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="projectSpend" label="项目预算">
            <el-select
              v-model="ruleForm.projectSpend"
              placeholder="请选择预算范围"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="projectDescribe" label="项目描述">
            <el-input
              type="textarea"
              placeholder="请输入项目描述"
              v-model="ruleForm.projectDescribe"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="expectDay" label="交付周期(天)">
            <el-input
              v-model.number="ruleForm.expectDay"
              placeholder="请输入期望交付周期"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contacts" label="联系人">
            <el-input
              v-model="ruleForm.contacts"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contactPhone" label="您的联系方式">
            <el-input
              v-model="ruleForm.contactPhone"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item prop="contactAdd" label="您的联系地址">
            <el-input
              v-model="ruleForm.contactAdd"
              placeholder="请输入联系地址"
            ></el-input>
          </el-form-item>
          <el-form-item prop="coverPic" label="参考图片">
            <el-upload
              ref="uploadRef"
              class="upload"
              action="http://8.136.151.147:8087/oss/upload"
              :data="getObject"
              :on-success="handleUploadSuccess"
              :before-upload="beforeAvatarUpload"
              v-show="false"
            >
            </el-upload>
            <div class="imgaeList">
              <div
                v-for="(item, index) in ruleForm.proPicList"
                :key="index"
                class="list"
              >
                <img :src="item" />
                <span class="mask">
                  <img
                    src="../assets/delete.png"
                    class="delete"
                    @click="handleRemove(item, index)"
                  />
                </span>
              </div>
              <div class="list2" @click="handleUpload">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <!-- 协议勾选框 核心修改：去掉border属性 -->
        <div class="agreement-checkbox">
          <el-checkbox v-model="isAgree">
            <span class="agreement-text">
              我已阅读并同意
              <a href="javascript:;" @click.stop="openAgreement"
                >《平台服务协议与管理制度》</a
              >
            </span>
          </el-checkbox>
        </div>
        <div class="submit-content-div">
          <!-- 提交按钮 动态置灰 -->
          <div
            class="submit-content-send"
            :class="{ 'btn-disabled': !isAgree }"
            @click="handleSubmit('ruleForm')"
          >
            {{ name }}
          </div>
          <!-- 删除按钮 动态置灰 仅修改模式显示 -->
          <div
            class="submit-content-delete"
            v-if="name == '修改'"
            :class="{ 'btn-disabled': !isAgree }"
            @click="handleDelete()"
          >
            删除
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  publishItem,
  getDetail,
  updateList,
  getToken,
  deleteById,
} from "../utils/publish";
import { login } from "../utils/login";
export default {
  name: "topsubmit",
  components: {},
  data() {
    return {
      ruleForm: {
        type: "",
        projectName: "",
        projectSpend: "",
        projectDescribe: "",
        expectDay: undefined,
        contactPhone: "",
        contacts: "",
        contactAdd: "",
        proPicList: [],
      },
      accessToken: undefined,
      name: "提交",
      // 协议勾选核心状态
      isAgree: false,
      rules: {
        type: [
          { required: true, message: "请选择项目类型", trigger: "change" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        projectSpend: [
          { required: true, message: "请选择预算范围", trigger: "change" },
        ],
        projectDescribe: [
          { required: true, message: "请输入项目描述", trigger: "blur" },
        ],
        expectDay: [
          { required: true, message: "请输入期望交付周期", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
      },
      options: [
        { label: "3万以下", value: "1" },
        { label: "3万-10万", value: "2" },
        { label: "10万-50万", value: "3" },
        { label: "50万以上", value: "4" },
      ],
      options2: [
        { label: "广告策划", value: 1 },
        { label: "企业咨询", value: 2 },
        { label: "数字内容制作", value: 3 },
        { label: "系统平台搭建", value: 4 },
      ],
    };
  },
  created() {
    this.getStatus();
    this.logon = JSON.parse(localStorage.getItem("loginstate")) || {};
  },
  mounted() {
    this.getStatus();
  },
  computed: {
    getObject() {
      let token = this.accessToken;
      return { token };
    },
  },
  methods: {
    getStatus() {
      let data = {
        mobilePhone: JSON.parse(localStorage.getItem("loginstate")).mobilePhone,
        password: JSON.parse(localStorage.getItem("loginstate")).password,
      };
      console.log(data, "----218---");
      login(data).then((res) => {
        console.log(res, "----218---");
        if (res.data && res.data.code == 200) {
          localStorage.setItem("loginstate", JSON.stringify(res.data.data));
          // setTimeout(()=>{
          //   this.$router.push("/");
          // },1000)
        } else if (res.data && res.data.code == 500) {
          this.$message.warning(res.data.data);
        } else {
          this.$message.error("登录失败,请重试");
        }
      });
    },
    // 核心修改：弹窗居中显示
    openAgreement() {
      // 弹窗宽高
      window.open("/agreement.html", "_blank");
    },
    // 提交表单 核心校验
    handleSubmit(formName) {
      // 协议勾选前置校验
      if (!this.isAgree) {
        this.$message.warning("请先阅读并同意《服务协议》");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.name == "提交") {
            publishItem(this.ruleForm).then((res) => {
              console.log("ccccccc", res);
              if (res.data.code == 200) {
                this.$message.success(res.data.data);
                let type = this.ruleForm.type;
                setTimeout(() => {
                  this.reset();
                  this.$store.commit("SET_ACTIVE", -1);
                  this.$router.push({ path: "/mine", query: { type: type } });
                }, 1500);
              } else if (res.data.code == 208) {
                this.$message.success(res.data.message);
                setTimeout(() => {
                  localStorage.removeItem("loginstate"),
                    this.$router.push("/login");
                }, 1500);
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else if (this.name == "修改") {
            updateList(this.ruleForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.data);
                let type = this.ruleForm.type;
                setTimeout(() => {
                  this.reset();
                  this.$store.commit("SET_ACTIVE", -1);
                  this.$router.push({ path: "/mine", query: { type: type } });
                }, 1500);
              } else if (res.data.code == 208) {
                this.$message.success("登录已经失效，请重新登录!");
                setTimeout(() => {
                  localStorage.removeItem("loginstate"),
                    this.$router.push("/login");
                }, 1500);
              } else {
                this.$message.error("修改项目失败,请重试!");
              }
            });
          }
          this.getStatus();
        }
      });
    },
    // 表单重置 同步重置协议勾选
    reset() {
      this.ruleForm = {
        type: "",
        projectName: "",
        projectSpend: "",
        projectDescribe: "",
        expectDay: undefined,
        contactPhone: "",
        contacts: "",
        contactAdd: "",
        proPicList: [],
      };
      this.isAgree = false;
    },
    // 上传图片
    handleUpload(file) {
      this.$nextTick(() => {
        this.$refs.uploadRef.$el.querySelector(".el-upload__input").click();
      });
    },
    // 移除图片
    handleRemove(imageUrl, index) {
      this.ruleForm.proPicList = this.ruleForm.proPicList.filter(
        (_, idx) => idx !== index,
      );
    },
    // 删除项目 前置协议校验
    handleDelete() {
      if (!this.isAgree) {
        this.$message.warning("请先阅读并同意《服务协议》");
        return;
      }
      this.$confirm("此操作将永久删除该项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteById(this.$route.query.id).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("删除成功!");
              let type = this.ruleForm.type;
              setTimeout(() => {
                this.reset();
                this.$store.commit("SET_ACTIVE", -1);
                this.$router.push({ path: "/mine", query: { type: type } });
              }, 1500);
            } else if (res.data.code == 208) {
              this.$message.success("登录已经失效，请重新登录!");
              setTimeout(() => {
                localStorage.removeItem("loginstate"),
                  this.$router.push("/login");
              }, 1500);
            } else {
              this.$message.error("删除失败,请重试!");
            }
          });
        })
        .catch(() => {});
    },
    // 图片上传前置校验
    beforeAvatarUpload(file) {
      let index = file.name.lastIndexOf(".");
      let extension = file.name.substr(index + 1);
      let extensionList = [
        "png",
        "PNG",
        "jpg",
        "JPG",
        "jpeg",
        "JPEG",
        "webp",
        "WEBP",
      ];
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message({
          message: "单张照片不可超出10M",
          type: "warning",
          center: true,
        });
        return false;
      } else if (extensionList.indexOf(extension) < 0) {
        this.$message({
          message: "当前文件格式不支持",
          type: "error",
          center: true,
        });
        return false;
      } else {
        return true;
      }
    },
    // 图片上传成功回调
    handleUploadSuccess(response, file) {
      if (response.code == 500) {
        this.$message({
          message: response.msg,
          type: "error",
          center: true,
        });
      } else if (response.data) {
        this.ruleForm.proPicList.push(response.data.path);
      }
    },
  },
  activated() {
    this.$route.query.type
      ? (this.ruleForm.type = Number(this.$route.query.type))
      : (this.ruleForm.type = "");
    if (this.$route.query.id) {
      getDetail({ id: this.$route.query.id }).then((res) => {
        if (res.data.code == 200) {
          this.ruleForm = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.name = "修改";
    } else {
      this.name = "提交";
    }
    this.getStatus();
    getToken().then((response) => {
      if (response.data.code == 200) {
        this.accessToken = response.data.data;
      } else {
        this.$message.error("获取token失败");
      }
    });
    // 进入页面重置协议勾选状态
    this.isAgree = false;
  },
  watch: {
    $route(to, from) {
      if (to.query.id !== from.query.id) {
        this.name = "提交";
        this.reset();
      }
    },
  },
};
</script>
<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
.submit {
  width: 100%;
  &-top {
    width: 100%;
  }
  &-background {
    width: 100%;
    background: url("../assets/cover.png") no-repeat;
    background-size: cover;
    padding-bottom: 80px;
  }
  &-content {
    width: 1500px;
    background: #ffffff;
    box-sizing: border-box;
    padding: 69px 280px;
    margin: -128px auto 0;
    z-index: 99;
    position: relative;
    p {
      .fontdemo(34px, "AlibabaPuHuiTi_2_65_Medium", 600, #000000);
      margin: 0 auto 0px;
    }
    &-sub {
      .fontdemo(22px, "PingFangSC, PingFang SC", 400, rgba(0,0,0,0.9));
      line-height: 60px;
      cursor: pointer;
      color: coral;
      text-align: left;
    }
    &-div {
      display: flex;
      align-items: center;
      margin-top: 72px;
      justify-content: center;
    }
    &-send {
      width: 230px;
      height: 60px;
      background: #4787f0;
      border-radius: 8px;
      .fontdemo(22px, "PingFangSC, PingFang SC", 500, #FFFFFF);
      line-height: 60px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
    }
    &-delete {
      width: 230px;
      height: 60px;
      background: #f2f2f2;
      border-radius: 8px;
      .fontdemo(22px, "PingFangSC, PingFang SC", 500, #000000);
      line-height: 60px;
      text-align: center;
      cursor: pointer;
      margin-left: 50px;
      transition: all 0.3s;
    }
  }
  /deep/ .el-textarea {
    height: 100%;
    .el-textarea__inner {
      height: 156px;
      border-radius: 3px;
      padding: 15px;
      resize: none;
      .fontdemo(16px, "PingFangSC, PingFang SC", 400, rgba(0,0,0,0.9));
    }
  }
  /deep/ .el-select,
  /deep/ .el-input {
    width: 100%;
    .el-input__inner {
      width: 100%;
      height: 60px;
      .fontdemo(16px, "PingFangSC, PingFang SC", 400, rgba(0,0,0,0.9));
    }
  }
  /deep/ .el-form-item__label {
    padding-right: 40px;
  }
}
/deep/ .el-form-item__label {
  font-size: 21px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  color: rgba(0, 0, 0, 0.85);
  line-height: 60px;
}
.imgaeList {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.list {
  margin-right: 42px;
  width: 147px;
  height: 147px;
  border-radius: 6px;
  margin-bottom: 30px;
  img {
    width: 100%;
    height: 147px;
    border-radius: 6px;
  }
  position: relative;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    opacity: 0;
    font-size: 20px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    width: 100%;
    height: 147px;
    border-radius: 6px;
    display: flex;
    cursor: pointer;
    .delete {
      width: 30px;
      height: 30px;
    }
  }
}
.list:hover .mask {
  opacity: 1;
}
.list2 {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 147px;
  height: 147px;
  border-radius: 6px;
  margin-bottom: 30px;
  &:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 147px;
    height: 147px;
    line-height: 147px;
    text-align: center;
  }
}
// 核心修改：美化协议勾选框样式
.agreement-checkbox {
  margin: 30px 0 0 180px;
  text-align: left;
  // 美化checkbox样式
  /deep/ .el-checkbox {
    font-size: 16px;
    // 勾选框大小
    .el-checkbox__inner {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border-color: #dcdfe6;
      transition: all 0.2s ease;
      // 勾选图标大小
      &::after {
        width: 8px;
        height: 12px;
      }
    }
    // hover状态
    &:hover .el-checkbox__inner {
      border-color: #4787f0;
    }
    // 选中状态
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #4787f0;
      border-color: #4787f0;
    }
    // 禁用状态
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
    }
  }
  .agreement-text {
    font-size: 16px;
    color: #666;
    cursor: default;
    line-height: 20px;
    margin-left: 8px;
    a {
      color: #4787f0;
      text-decoration: underline;
      margin: 0 4px;
      cursor: pointer;
      // 链接hover效果
      &:hover {
        color: #3071d9;
      }
    }
  }
}
// 按钮置灰样式 核心禁用逻辑
.btn-disabled {
  background: #cccccc !important;
  color: #999999 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
  user-select: none;
}
</style>
